type SkeletonBoxProps = {
  className?: string;
};

export const SkeletonBox = ({ className }: SkeletonBoxProps) => (
  <div
    className={`
      animate-pulse rounded-md bg-base-secondary
      ${className}
    `}
  />
);
